<script>
export default
{
    name: 'order-column',

    props:
    {
        field: null,
    },

    methods:
    {
        order()
        {
            this.$router.push({ query: this.$route.query, params: {
                page: this.$route.params.page,
                sort: this.field,
                order: this.$route.params.sort == this.field && this.$route.params.order == 'desc' ? 'asc' : 'desc',
                search: this.$route.params.search || null,
            }})
        },
    }
}
</script>

<template>
<th @click="order" class="cp user-none">
    <slot></slot>
    <i class="fal fa-long-arrow-down" v-if="$route.params.sort == field && $route.params.order == 'asc'"></i>
    <i class="fal fa-long-arrow-up" v-if="$route.params.sort == field && $route.params.order == 'desc'"></i>
</th>
</template>



// WEBPACK FOOTER //
// src/components/elements/OrderColumn.vue